import { FileNameExtensions } from "extensions/FileNameExtensions";
export interface ICamIV64File {
    filePath: string;
    createDate: Date;
}

export enum CamIV64FileType {
    SpecialMeasurement,
    Image,
    Measurement,
    SorX,
    Other,
}

export class CamIV64File implements ICamIV64File {
    filePath: string;
    name: string;
    fileType: CamIV64FileType;
    createDate: Date;

    constructor(filePath: string, createDate: Date) {
        this.filePath = filePath;
        this.createDate = createDate;
        this.name = FileNameExtensions.getName(filePath);
        this.fileType = this.getCamIV64FileType(FileNameExtensions.getExtension(filePath));
    }

    getCamIV64FileType(extension: string): CamIV64FileType {
        switch (extension) {
            case "jpg":
            case "png":
            case "jpeg":
                return CamIV64FileType.Image;
            case "sor":
                return CamIV64FileType.Measurement;
            case "sorx":
                return CamIV64FileType.SorX;
            case "json":
                return CamIV64FileType.SpecialMeasurement;
            default:
                return CamIV64FileType.Other;
        }
    }
}
